<template>
    <ui-dropdown :menuClass="'p-3 '+getWidth()" :ref="'dropdown'">
        <template #default="{ toggle }">
            <div class="relative w-[22px] h-[22px] mt-0"
                 :class="(readonly||(components.length===0))?'':'cursor-pointer'"
                 @mouseover="(readonly||(components.length===0))?false:mouseover()"
                 @mouseout="(readonly||(components.length===0))?false:mouseout()"
                 @click="(readonly||(components.length===0))?false:toggle()"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22px"
                    height="22px"
                    viewBox="0 0 36 36"
                    :fill="fill"
                    :stroke="stroke"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="absolute"
                    style="left: 0px; top: 0px"
                >
                    <circle cx="18" cy="18" r="17"/>
                </svg>
                <div class="flex justify-center text-blue-500 relative mt-px" v-if="item.component">
                    <div class="mt-0.5 font-bold leading-4 pt-px" style="font-size: 0.6em"
                         v-text="item.component.name.substring(0,3)" :key="renderKey"></div>
                </div>
            </div>
        </template>
        <template #menu="{ close }">
            <div :key="renderKey">
                <ui-dropdown-item v-for="(comp,index) in (components)"
                                  :class="'focus:ring-0'"
                                  :key="index"
                                  :ticked="item.componentId === comp.id"
                                  @click="applyComponent(comp, close)"
                >
                    <div class="cursor-pointer relative w-[22px] h-[22px] mt-0 ml-1 mr-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            height="22px"
                            viewBox="0 0 36 36"
                            fill="#FFFFFF"
                            :stroke="stroke"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="absolute"
                            style="left: 0px; top: 0px"
                        >
                            <circle cx="18" cy="18" r="17"/>
                        </svg>
                        <div class="flex justify-center text-blue-500 relative">
                            <div class="mt-0.5 font-bold leading-4" style="font-size: 0.6em; padding-top:1px"
                                 v-text="comp.name.substring(0,3)"></div>
                        </div>
                    </div>
                    <div v-text="comp.name" class="flex-1 text-left">
                    </div>
                </ui-dropdown-item>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdownDivider from "../../../ui/UiDropdownDivider.vue";

export default {
    components: {UiDropdownDivider, UiDropdownItem},
    props: {
        readonly: false,
        item: Object,
        components: Array,
    },
    watch: {},
    computed: {},
    data() {
        return {
            fill: '#FFFFFF',
            stroke: 'rgb(59 130 246)',
            renderKey: 0,
        }
    },
    mounted() {
    },
    methods: {
        mouseover() {
            this.fill = 'rgb(239 246 255)'
        },
        mouseout() {
            this.fill = '#FFFFFF'
        },
        applyComponent(component, close) {
            if (this.item.component === component) {
                delete this.item.component
                this.item.componentId = ''
            } else {
                this.item.component = component
                this.item.componentId = component.id
                close();
            }
            this.renderKey++;
            this.$emit('componentUpdated')
        },
        getWidth() {
            const max = this.components.reduce((prev, current) => ((prev && prev.name.length > current.name.length) ? prev : current), false)
            if (!max || max.name.length < 20) {
                return 'w-64'
            } else if (max.name.length < 25) {
                return 'w-72'
            } else {
                return 'w-96'
            }
        }
    },
}
</script>